import React from 'react';
import { MAIN_MOCKUP_URL, PAGE_IMAGES } from '../data/assets';
type ProductStackProps = {
  label?: string;
  className?: string;
};

/**
 * Imagen de producto. Si hay mockup principal (data/assets.ts) se usa ese;
 * si no, un abanico con tres páginas reales del Volumen 4.
 */
export function ProductStack({
  label = '6 volumes · 60 sessions',
  className = ''
}: ProductStackProps) {
  if (MAIN_MOCKUP_URL) {
    return <img src={MAIN_MOCKUP_URL} alt="The six Acro Yoga Class Ready volumes lined up in a sunlit studio" className={`mx-auto h-auto w-full rounded-3xl shadow-stack ring-1 ring-black/10 ${className}`} data-id="element-300" data-mp="dc756f95v7qy" />;
  }
  return <div className={`relative mx-auto aspect-[20/19] w-full max-w-[440px] ${className}`} data-id="element-301" data-mp="r4dh1p5a6skl">
      <img src={PAGE_IMAGES.sessionCard} alt="A Session Card page: room map with trios on mats, five-block timeline and scripts" className="absolute left-[3%] top-[9%] w-[38%] -rotate-[8deg] rounded-2xl shadow-stack ring-1 ring-black/10" data-id="element-302" data-mp="w3q5gebsw7pa" />
      <img src={PAGE_IMAGES.threeLane} alt="A 3-lane skill page teaching candlestick in Ground, Lift and Fly lanes" className="absolute right-[3%] top-[9%] w-[38%] rotate-[8deg] rounded-2xl shadow-stack ring-1 ring-black/10" data-id="element-303" data-mp="1iz6dzr7tyko3" />
      <img src={PAGE_IMAGES.cover} alt="Acro Yoga Class Ready Volume 4 cover: Inversions, Pops and Standing Basics" className="absolute left-1/2 top-0 z-10 w-[46%] -translate-x-1/2 rounded-2xl shadow-stack ring-1 ring-black/10" data-id="element-304" data-mp="152jhtqnpbyj8" />
      <span className="absolute bottom-0 left-1/2 z-20 -translate-x-1/2 whitespace-nowrap rounded-full bg-saffron px-4 py-2 font-display text-[12px] font-bold uppercase tracking-wide text-night shadow-card" data-id="element-305" data-mp="1szgt5hdfe25w">
        {label}
      </span>
    </div>;
}